import { createSlice } from '@reduxjs/toolkit';

export type State = {
  isOnline: boolean;
  displayMessage: boolean;
};

const initialState: State = {
  isOnline: true,
  displayMessage: false,
};

const slice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    deviceOnline: (state) => {
      state.isOnline = true;
      state.displayMessage = true;
    },
    deviceOffline: (state) => {
      state.isOnline = false;
      state.displayMessage = true;
    },
    hideMessage: (state) => {
      state.displayMessage = false;
    },
  },
});

export const actions = slice.actions;
export default slice.reducer;
